module.exports = __webpack_public_path__ + "static/Calluna-Regular-webfont-abc525989a7ada9c329fcef081ee3286.woff2";